import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { AdvCard, AdvDesc, AdvTitle } from "./style";
import { JoinButton } from "../header/style";
import { Link } from "react-scroll";
import Signup from "../Signup";

const pointsRow1 = [
  {
    name: "Personalized Learning",
    desc: `AI that adapts to your child's needs.
    Tnikola uses advanced AI algorithms to evaluate how students respond to questions,
     identifying their strengths and areas where they need improvement. 
    .`,
  },
  {
    name: "Interactive Step-by-Step Hints",
    desc: `Understand each problem thoroughly.
    Tnikola doesn’t just provide answers – it teaches how to solve problems. 
    Students can request hints one step at a time, helping them think critically and stay involved in the problem-solving process.
     `,
  },
  {
    name: "Fun Rewards System",
    desc: `Earn points and achievements as you learn.
    Learning doesn’t have to feel like a chore! Tnikola makes studying fun by turning progress into a game. 
    `,
  },
];

const pointsRow2 = [
  {
    name: "Teaching Tools",
    desc: `Built-in guidelines for educators to enhance teaching.
        Tnikola is designed not just for students but also for educators. 
        Teachers and parents can access step-by-step teaching guides, making it easier to explain complex problems. 
        `,
  },
  {
    name: " Smart AI Teacher",
    desc: `Always ready to support and encourage progress.
        Imagine having a personal tutor available 24/7, 
        ready to adapt and help whenever needed. `,
  },
  {
    name: " AI-Powered Video Recommendations",
    desc: `Learn with curated video content for every topic.
        Tnikola goes beyond questions by leveraging AI to recommend the best learning videos for each topic.`,
  },
];

const Advertisement = () => {
  return (
    <>
      <Box
        component="section"
        sx={{
          display: "flex",

          alignItems: "left",
          justifyContent: "left",
          flexDirection: "column",
          // paddingLeft: "12rem",
          // // marginLeft: "12rem",
          // paddingRight: "6rem",
          // paddingTop:
          paddingLeft: "22rem",
          paddingRight: "12rem",
          paddingTop: "3rem",
          paddingBottom: "3rem",
          backgroundColor: "#ffffff",
          width: "100%",

          // backgroundColor: "#ffb319",
          marginBottom: "8rem",
        }}
      >
        <Typography
          variant="h4" // Adjust the size as needed
          component="h2"
          sx={{
            fontWeight: "bold",
            color: "#1A202C", // Adjust the color to match the image
            marginBottom: "2rem",
          }}
        >
          Why choose Tnikola ?
        </Typography>
        <div>
          <Stack direction="row" spacing={5}>
            {pointsRow1.map((point) => {
              return (
                <AdvCard>
                  <AdvTitle>
                    <h3>{point.name}</h3>
                  </AdvTitle>
                  <AdvDesc>{point.desc}</AdvDesc>
                </AdvCard>
              );
            })}
          </Stack>
          <Stack direction="row" spacing={5} sx={{ marginTop: "5rem" }}>
            {pointsRow2.map((point) => {
              return (
                <AdvCard>
                  <AdvTitle>
                    <h3>{point.name}</h3>
                  </AdvTitle>
                  <AdvDesc>{point.desc}</AdvDesc>
                </AdvCard>
              );
            })}
          </Stack>
        </div>
      </Box>
      <div
        style={{
          position: "relative",
          top: "-5rem",
          marginLeft: "45%",
          //   marginBottom: "5rem",
        }}
      >
        <Signup />
      </div>
    </>
  );
};

export default Advertisement;
